export default class HeaderEditionSelection {
    constructor(dropdown) {
        this.fetchDomElements(dropdown);
        this.registerEventListeners();
    }

    fetchDomElements(dropdown) {
        this.domElements = {};
        this.domElements.dropdown = dropdown;
        this.domElements.toggle   = this.domElements.dropdown.querySelector('.dropdown-toggle');
        this.domElements.menu     = this.domElements.dropdown.querySelector('.dropdown-menu');
        this.domElements.selected = this.domElements.dropdown.querySelector('.selectedEdition');
        this.domElements.items    = this.domElements.menu.querySelectorAll('.dropdown-item');
    }

    registerEventListeners() {
        this.domElements.toggle.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggleDropdown();
        });

        for (const item of this.domElements.items) {
            item.addEventListener('click', (event) => this.onItemClick(event.target));
        }

        document.addEventListener('click', (event) => {
            if (!this.domElements.dropdown.contains(event.target)) {
                this.closeDropdown();
            }
        });
    }

    closeDropdown() {
        this.domElements.dropdown.classList.remove('open');
    }

    openDropdown() {
        this.domElements.dropdown.classList.add('open');
    }

    toggleDropdown() {
        this.domElements.dropdown.classList.toggle('open');
    }

    getSelectedValue() {
        return this.domElements.menu.querySelector('.dropdown-item.active')?.dataset.value;
    }

    setActiveItem(item) {
        for (const i of this.domElements.items) {
            i.classList.remove('active');
        }
        item.classList.add('active');
    }

    async onItemClick(item) {
        const newValue = item.dataset.value;
        const currentValue = this.getSelectedValue();

        if (newValue === currentValue) {
            this.closeDropdown();
            return;
        }

        this.setActiveItem(item);
        this.domElements.selected.textContent = item.textContent;
        this.closeDropdown();

        const dropdownName = this.domElements.dropdown.dataset.name;
        const payload = { [dropdownName]: newValue };

        try {
            const res = await fetch('/?fnc=changeuseredition', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            //window.location.reload();
            window.location.href = '/';
        } catch (error) {
            console.error(error);
        }
    }
}
